import * as React from "react";
import classes from "./news.module.css"

const News = () => {
	return (
		<div className={classes.news}>News</div>
	)
}

export default News